import ApiService, { callCustomMethodAsync } from '../service/ApiService';

let moduleApi = {};
let moduleName = "news";

moduleApi.create = async (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id},
    message:{
      success: "",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ApproveNews = async (id) => {
  let api = {
    module: moduleName,
    body: {
      id: id
    },
    type: "ApproveNews",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
